/**
 * Утилиты для работы с датами
 */

/**
 * Конвертирует дату в UTC формат для отправки на бэкенд
 * @param date - Дата в формате string, Date или undefined
 * @returns Date объект в UTC или undefined если дата не указана
 */
export function convertToUtcDate(date: string | Date | undefined): Date | undefined {
  if (!date) {
    return undefined;
  }

  if (typeof date === 'string') {
    // Если строка в формате yyyy-MM-dd, создаем Date в UTC
    //if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
    //  return new Date(date + 'T00:00:00.000Z');
    //}
    // Иначе парсим и конвертируем в UTC
    const parsedDate = new Date(date);
    return new Date(parsedDate.getTime() - (parsedDate.getTimezoneOffset() * 60000));
  }

  // Если уже Date, конвертируем в UTC
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
}

/**
 * Конвертирует Date объект в строку для HTML input[type="date"]
 * @param date - Date объект, строка или undefined
 * @returns Строка в формате YYYY-MM-DD
 */
export function formatDateForInput(date: string | Date | undefined): string {
  if (!date) {
    return '';
  }

  if (typeof date === 'string') {
    // Если строка в ISO формате с временем, извлекаем только дату
    if (date.includes('T')) {
      return date.split('T')[0];
    }
    // Если строка уже в формате yyyy-MM-dd, возвращаем как есть
    return date;
  }

  return date.toISOString().split('T')[0];
}

/**
 * Проверяет, является ли дата валидной
 * @param date - Дата для проверки
 * @returns true если дата валидна
 */
export function isValidDate(date: any): boolean {
  return date instanceof Date && !isNaN(date.getTime());
}
